export default __webpack_public_path__ + "static/media/eatfresh.ce823603.jpg";